import { summarySend } from 'common/constants/permissions';

const canSendFromShowAll = permissions => !!permissions[summarySend];

export default {
    canSendFromShowAll
};
